<template>
  <div class="my-item3 z-info">
    <template v-if="activityList && activityList.length > 0">
      <div style="min-height: 400px;margin-bottom:20px;">
        <Row :gutter="30">
          <Col span="6" v-for="(item, index) in activityList" :key="'act-' + index" class="w-20">
            <div class="activity-list-one">
              <div class="activity-imgbox">
                <img v-if="item.banner && item.banner[0]" :src="item.banner[0]" />
                <img src="@/assets/img/empty.png" v-else />
              </div>
              <div class="activity-name" :title="item.name">{{item.name}}</div>
              <div class="activity-btn">
                <div class="txt" @click="showEdit(item)">编辑</div>
                <div class="activity-btn-line"></div>
                <div class="txt" @click="setTopic(item)">推荐</div>
                <div class="activity-btn-line"></div>
                <div class="txt">
                  <Dropdown trigger="custom" :visible="item.visible">
                    <a href="javascript:void(0);" style="color:#808080;" @click="toggleOpen(index)">
                      更多
                      <Icon type="ios-arrow-down"></Icon>
                    </a>
                    <DropdownMenu slot="list" style="text-align:center;">
                      <DropdownItem v-if="item.isShow" @click.native="setShow(item)">屏蔽</DropdownItem>
                      <DropdownItem v-if="!item.isShow" @click.native="setUnShow(item)">显示</DropdownItem>
                      <DropdownItem>
                        <Poptip
                          confirm
                          placement="top-start"
                          title="确认删除此活动吗 ?"
                          @on-ok="delItem(item, index)"
                          @on-cancel="handleClose(index)"
                        ><div style="width: 100px;">删除</div></Poptip>
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <div class="my-page" v-if="totalCount > pageSize" style="text-align:center;">
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </div>
    </template>
    <emptyList v-else @change="Add()"></emptyList>

    <!-- 修改展商置顶 -->
    <exTopic
      :show="editTopic"
      v-if="editTopic"
      @finish="init()"
      :editTopicnfo="editTopicnfo"
      @close="editTopic=false;editTopicnfo=null;"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import emptyList from "@components/emptyList/emptyList";
import exTopic from "../../../../components/ex-topic.vue";

export default {
  name: "exhibition-act-item",
  props: {
    searchField: {
      type: String,
      default() {
        return "1";
      }
    },
    joinId: {
      type: String,
      default() {
        return '';
      }
    },
  },
  data() {
    return {
      deleted: false,
      edit: false,
      editInfo: null,
      activityList: [], // 活动列表

      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      editTopic: false,
      editTopicnfo: null,
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany"
    }),
    option() {
      return {
        By: this.joinId,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "Name",
                  Value: `%${this.searchField}%`
                }
              }
            ]
          }
        }
      };
    }
  },
  components: {
    emptyList,
    exTopic
  },
  created() {
    if(this.joinId) { 
      this.init();
    }
  },
  methods: {
    ...mapActions({
      getActivityByJoinIdAll: "activityModuleNew/getActivityByJoinIdAll",
      setActivityShow: "activityModuleNew/setActivityShow",
      delActivity: "activityModuleNew/delActivity"
    }),
    async init() {
      let actData = await this.getActivityByJoinIdAll(this.option);
      console.log('活动',actData);
      if (actData) {
        actData.items.map(c => {
          if (c.banner) {
            c.banner = JSON.parse(c.banner);
          }
          c.visible = false;
        });
        this.activityList = actData.items;
        this.pageSize = actData.pageSize;
        this.pageIndex = actData.pageIndex;
        this.totalCount = actData.totalCount;
      }
    },
    Add() {
      this.$router.push(`/host/index/ex/act-add?compId=${this.$route.query.id}`);
    },
    showEdit(item) { 
      this.$router.push(`/host/index/ex/act-edit?id=${item.id}&compId=${this.$route.query.id}`);
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    },
    toggleOpen(index) {
      let visible = this.activityList[index].visible;
      this.activityList[index].visible = !visible;
    },
    async setShow(item) {
      let req = {
        Id: item.id,
        IsShow: false
      };
      let result = await this.setActivityShow(req);
      if (result && result.successed) {
        this.$Message.success("修改成功");
        this.init();
      } else {
        this.$Message.error("修改失败，请重新尝试");
      }
    },
    async setUnShow(item) {
      let req = {
        Id: item.id,
        IsShow: true
      };
      let result = await this.setActivityShow(req);
      if (result && result.successed) {
        this.$Message.success("修改成功");
        this.init();
      } else {
        this.$Message.error("修改失败，请重新尝试");
      }
    },
    async delItem(item) {
      let result = await this.delActivity(item.id);
      if (result && result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
      item.visible = false;
    },
    handleClose(index) {
      this.activityList[index].visible = false;
    },
    setTopic(item) {
      // 设置置顶
      this.editTopicnfo = item;
      this.editTopic = true;
    },
  }
};
</script>

<style lang="scss">
.activity-list {
  min-width: 600px;
  padding: 30px 30px 100px 30px;
  &-one {
    background-color: #fff;
    margin-bottom: 20px;
    .activity-imgbox {
      width: 100%;
      padding-bottom: 66.666667%;
      position: relative;
      img {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        max-height: 100%;
      }
    }
    .activity-name {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 10px 10px;
    }
    .activity-btn {
      font-size: 14px;
      height: 48px;
      text-align: center;
      color: #808080;
      cursor: pointer;
      display: flex;
      align-items: center;
      .txt {
        display: inline-block;
        width: 32%;
      }
      &-line {
        display: inline-block;
        width: 1px;
        height: 30px;
        background-color: #e8e8e8;
        padding-top: 18px;
      }
      &-del {
        height: 34px;
        padding: 7px 16px;
        color: #333;
        &:hover {
          background: #f3f3f3;
        }
      }
    }
  }
}
</style> 
